import React from 'react'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faPlusCircle } from '@fortawesome/free-solid-svg-icons'

class ShadowAccountProfile extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      shadowAccountId: null,
      shadowAccountNo: ""
    }
  }

  onChange = (name, value) => {
    this.setState({ [name]: value })
  }

  render() {
    let { props } = this
    return (
      <React.Fragment>
        <Row>
          <Col>
            <ShadowAccountForm list={props.shadowAccountProfile} onDelete={props.onDelete} onAdd={props.onAdd} onChange={props.onChange} action={props.action} />
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}
export default ShadowAccountProfile

const ShadowAccountForm = ({ action, onAdd, onDelete, onChange, list = [] }) => {
  const shadowAccountList = list.map((value, index, arr) => {
    return (
      <Row key={value.shadowAccountId} className="pb-2">
        <Col sm={6} className="pr-2">
          <Form.Group className="mb-1 d-flex">
            <Form.Check
              name={"isShadowAccount"}
              className="mt-2"
              disabled={true}
              type="checkbox"
              checked={value.isShadowAccount=="A"||value.isShadowAccount=="Y"?true:false} />
            <Form.Control
              maxLength={10}
              name={"shadowAccountNo"}
              disabled={true}
              required
              value={value.shadowAccountNo}
              placeholder={"Enter Shadow Account Number"} />
          </Form.Group>
        </Col>
      </Row>
    )
  }
  );

  return (
    <React.Fragment>
      <Row className="pt-2">
        <Col sm={5} className="pr-2">
          <Form.Label className={"text-grey font-weight-bold medium required"}>Shadow Account Number</Form.Label>
        </Col>
      </Row>
      {shadowAccountList}
    </React.Fragment>
  );

}